import React from "react";

import HeaderWrapper from "../../header/header-wrapper";
import Newsletter from "../../molecules/Newsletter";

const list = [
  { id: 1, name: "All Sections" },
  { id: 2, name: "Entertainments" },
  { id: 3, name: "Sports" },
  { id: 4, name: "Movies" }
];

const NewslettersPage = () => (
  <div>
    <HeaderWrapper hideTopAd={true} />
    <Newsletter list={list} />
  </div>
);

export { NewslettersPage };
